/* 全局批量注册自定义指令 */
import dialogDrag from "./dialog/drag";
import dialogDragWidth from "./dialog/dragWidth";
import dialogDragHeight from "./dialog/dragHeight";
import clipboard from "./module/clipboard";
import divDrag from "./divDrag/divDrag";
import dialogOut from "./dialogOut";

// 自定义指令
const directives = {
  clipboard,
  dialogDrag,
  dialogDragWidth,
  dialogDragHeight,
  divDrag,
  dialogOut,
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
